
import { useState, useEffect } from 'react';
import tournamentService from '../../services/tournamentService';

export const useControllerData = (tournamentId, locationState, t, navigate, showNotification) => {
  const [initialData, setInitialData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTournamentData = async () => {
      if (tournamentId) {
        setIsLoading(true);
        const { data: tournament, error } = await tournamentService.getTournamentById(tournamentId);
        if (error) {
          showNotification(t('errors.tournament.fetchFailed'), 'error');
          navigate('/');
          return;
        }
        if (tournament) {
          setInitialData(tournament);
        }
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    };

    if (locationState && locationState.initialData) {
      setInitialData(locationState.initialData);
      setIsLoading(false);
    } else {
      fetchTournamentData();
    }
  }, [tournamentId, navigate, showNotification, t, locationState]);

  return { initialData, setInitialData, isLoading };
};
